<template>
    <div><!-- 訂單狀況查詢報表 -->
        <CCard class="w-100">
            <CCardHeader class="header_group">
                <strong>{{i18n('SearchBar_Vue.DocumentStatusQueryHeaderText')}}</strong>
                <div class="d-flex justify-content-end">
                    <button class="btn btn-edit mb-2 mr-2" @click="orderStatusPrintEvent">{{$t('Buttons.Print')}}</button>
                    <button class="btn btn-info mb-2 mr-2" @click="orderStatusReportExport">{{$t('Buttons.ExportOrder')}}</button>
                    <router-link class="btn btn-dark mb-2" to="ordersearch">{{$t('Buttons.GoBack')}}</router-link>
                </div>
            </CCardHeader>
            <CCardBody>
                <CNavbar light color="light">
                    <CForm>
                        <div class="CForminline">
                            <div class="supplier">
                                <p>{{i18n('OrderInfo_Vue.VendorId')}}：</p>
                                <p>{{orderQueryParam.vendorId}}</p>
                            </div>

                            <div class="date_range">
                                <p>{{i18n('OrderInfo_Vue.OrderDate')}}：</p>
                                <p>{{orderQueryParam.orderDateBegin}} ~ {{orderQueryParam.orderDateEnd}}</p>
                            </div>

                            <div class="number_range">
                                <p>{{i18n('OrderInfo_Vue.OrderNo')}}：</p>
                                <p>{{orderQueryParam.orderNoBegin}} ~ {{orderQueryParam.orderNoEnd}}</p>
                            </div>
                            
                            <div class="watch">
                                <p>{{i18n("OrderInfo_Vue.OrderViewed")}}：</p>
                                <p>{{isViewedText}}</p>
                            </div>

                            <div class="check">
                                <p>{{i18n('OrderInfo_Vue.OrderConfirm')}}：</p>
                                <p>{{isConfirmText}}</p> 
                            </div>                            
                        </div>
                    </CForm>
                </CNavbar>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardBody class="table_body">
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="">{{i18n('DocumentStatusQueryTable.PurchasingDocument')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.DocumentVersion')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.DocumentDate')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.No')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.Material')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.MaterialVersion')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.ShortText')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.Unit')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.DeliveryDate')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.Tax')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.Currency')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.NetPrice')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.POQuantity')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.DeliveredQuantity')}}</th>
                            <th class="text-center text-danger">{{i18n('DocumentStatusQueryTable.UnpaidQuantity')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.PurchaseGroup')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.Reviewed')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.VendorConfirm')}}</th>
                            <th class="text-center">{{i18n('DocumentStatusQueryTable.CaseClosed')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-light" v-for="(item , index) in reportResultList" :key="'reportRow_'+ index">
                            <td class="text-center">{{item.bsart + '-' + item.ebeln}}</td>
                            <td class="text-center">{{item.zzebver}}</td>
                            <td class="text-center">{{fixDate(item.aedat)}}</td>
                            <td class="text-center">{{fixNumber(item.ebelp)}}</td>
                            <td class="text-center">{{item.matnr}}</td>
                            <td class="text-center">{{item.revlv}}</td>
                            <td class="text-center">{{item.txz01}}</td>
                            <td class="text-center">{{item.meins}}</td>
                            <td class="text-center">{{fixDate(item.eindt)}}</td>
                            <td class="text-center">{{item.taxRate | currencyF2}}%</td>
                            <td class="text-center">{{item.waers}}</td>
                            <td class="text-center">{{item.netpr | currencyF5}}</td>
                            <td class="text-center">{{item.menge | currencyF3}}</td>
                            <td class="text-center">{{item.grqty | currencyF3}}</td>
                            <td class="text-center">{{calcShortage(item) | currencyF3}}</td>                            
                            <td class="text-center">{{item.ekgrpTxt}}</td>
                            <td class="text-center">{{item.isViewTxt}}</td>
                            <td class="text-center">{{item.confirmTimeTxt}}</td>
                            <td class="text-center">{{fixZclose(item.zclose)}}</td>
                        </tr>
                    </tbody>
                </table>                
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { orderMixin } from '@/mixin/order'
export default {
    mixins: [orderMixin],
    data() {
        return {  
            orderQueryParam :{  
                vendorId: '',
                orderDateBegin: '',
                orderDateEnd: '',
                orderNoBegin: '',
                orderNoEnd: '',
                isViewed: '',
                isConfirm: ''
            },
            searchType: 'Order',
            reportResultList: [],
            reportPrintToken : ''
        }
    },
    props : {
    },
    methods: {
        doOrderReportSearch (orderQueryParam){//報表相關資料取得
            const self =this;
            const param = orderQueryParam;
            const url = `${this.$apiUrl_Order}/SearchOrderReportAsync`;            
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--成功          
                    const respObj = response.data; 
                    const rows = respObj.rows;     
                    this.reportPrintToken = respObj.token;
                    rows.forEach(r => {
                        //aedat 訂單日期
                        let aedat = r.aedat;
                        r.aedat = self.fixDate(aedat);
                        let isView = self.fixIsView(r.isView);//看過否
                        r.isViewTxt = isView;
                        let confirmTime = self.fixConfirmTime(r.confirmTime);//廠商確認
                        r.confirmTimeTxt = confirmTime
                    });
                    self.reportResultList = rows;
                }                    
            })  
        },
        calcShortage (item){
            if(item.bstyp === 'L'){
                return 0;
            }
            return item.menge - item.grqty;
        },
        orderStatusPrintEvent (){
            const token= this.reportPrintToken;
            const url = `${this.$apiUrl_Print}/PrintSearchOrderReportAsync/${token}`;
            this.openNewTabByALink('orderPrint',url);
        },
        orderStatusReportExport (){ //匯出
            const token= this.reportPrintToken;
            const url = `${this.$apiUrl_Order}/SearchOrderReportExportExcel/${token}`;
            this.openNewTabByALink('orderExportExcel',url);
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        isViewedText (){
            const {isViewed} = this.orderQueryParam;
            if(isViewed ==='Y'){
                return 'Y';
            }else if(isViewed ==='N'){
                return 'N';
            }else{
                return this.i18n('Text.TranslateAll');
            }
        },
        isConfirmText (){
            const {isConfirm} = this.orderQueryParam;
            if(isConfirm ==='Y'){
                return '未確認';
            }else if(isConfirm ==='N'){
                return '已確認';
            }else{
                return this.i18n('Text.TranslateAll');
            }
        },
    },
    mounted() {     
        this.getCacheQueryParam('Report_QueryParam' , this.orderQueryParam);
        this.doOrderReportSearch(this.orderQueryParam);         
    }
}
</script>
<style lang="scss" scoped>
.table_body {
    overflow: auto;
    // overflow-y: auto;
    // overflow: auto;
    padding: 20px;
    > .table {
        // display: inline-block;
        margin-right: 0 20px;
        // padding-right: 20px;
    }
}
.card-header {
    display: flex;
    align-items: center;
    justify-content: center;
}
.btn-edit {
    background-color: #343b55;
    color: white;
}

.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .supplier, .date_range, .number_range, .watch, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
    }
}
.header_group {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>



